//@import dependencies
import parse from 'html-react-parser'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
//@end

import { ScreenNotificationsUtil } from 'app_utils/screenNotification'

//@import components
import DataTableComponent from 'app_components/commons/dataTable'
import EmptyStateCommon from 'app_components/commons/emptyState'
//@end

// @import hooks
// @end

// @INFO Import types
import { ICourseSchedulingEnrollmentListItem } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../modalGenerateCertificationsModule.scss'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'

// @ADD Component types
interface IModalGenerateCertificationsModuleLayoutProps {
  open: boolean
  processing: boolean
  loading: boolean
  handleClose: (data: any) => void
  onHandleSubmit: (data: any) => void
  errors: Array<any>
  schedulingMode: string
  previewCertificateParams: any
  isAuditorCerficateEnabled: boolean
  firstCertificateIsAuditor: boolean
  students: ICourseSchedulingEnrollmentListItem[]
  courseScheduling: ICourseSchedulingListItem
}

const ModalGenerateCertificationsModuleLayout: React.FC<IModalGenerateCertificationsModuleLayoutProps> = (props) => {

  const screenNotifications = new ScreenNotificationsUtil()

  const { t } = useTranslation()
  const formHook = useForm()

  const [isCheckAll, setIsCheckAll] = useState<boolean>(false)
  const [isCheck, setIsCheck] = useState<Array<any>>([])

  const handleSelectAll = (e: any) => {
    setIsCheckAll(!isCheckAll)
    setIsCheck(props.students.map(li => `student_${li.user._id}`))
    if (isCheckAll) {
      setIsCheck([])
    }
  }

  const handleCheckClick = (e: any) => {
    const { id, checked } = e.target
    setIsCheck([...isCheck, id])
    if (!checked) {
      setIsCheck(isCheck.filter(item => item !== id))
    }
  }

  const { open } = props

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  const headerKeysByMode = () => {
    if (props.schedulingMode.toLowerCase() === 'virtual') {
      return [
        `${t('screens.course_scheduling.certifications.generate_certification.completion')}`,
        `${t('screens.course_scheduling.certifications.generate_certification.average_grade')}`,
      ]
    }
    else {
      return [
        `${t('screens.course_scheduling.certifications.generate_certification.assistance')}`,
        // `${t('screens.course_scheduling.certifications.generate_certification.quiz_grade')}`,
      ]
    }
  }

  const keysByMode = () => {
    if (props.schedulingMode.toLowerCase() === 'virtual') {
      return ['progress.completion', 'progress.average_grade']

    }
    else {
      return ['progress.assistance']
      //'progress.quizGrade']
    }
  }

  const headerKeysForAuditorCertificate = () => {

    if (props.isAuditorCerficateEnabled) {
      return [
        `${t('screens.course_scheduling.certifications.generate_certification.auditor_certificate')}`,
        `${t('screens.course_scheduling.certifications.generate_certification.auditor_test')}`,
      ]
    }
    else if (props.firstCertificateIsAuditor) {
      return [
        `${t('screens.course_scheduling.certifications.generate_certification.auditor_test')}`,
      ]
    }
    else
      return []

  }
  const keysForAuditorCertificate = () => {
    if (props.isAuditorCerficateEnabled) {
      return ['progress.auditorCertificate', 'progress.auditorGradeC2']
    }
    else if (props.firstCertificateIsAuditor) {
      return ['progress.auditorGradeC1']
    }
    else
      return []

  }

  const handleFormSubmit = (data: any) => {
    const { hasWarnings, warnings: warningsLi } = warnings(false)
    if (hasWarnings && warningsLi) {
      let confirm = screenNotifications.fire({
        message: warningsLi as string,
      },
      {
        type: 'error',
        confirmButtonText: `Continuar`,
        cancelButtonText: `Cancelar`,
        showCancelButton: true,
      })

      if (confirm) {

        confirm.then(async (result) => {
          if (result.value) {
            props.onHandleSubmit(data)
          }
        })
      }
    } else {
      props.onHandleSubmit(data)
    }
  }

  const warnings = (component = true) => {
    let warnings;
    if (props.previewCertificateParams?.warnings && Array.isArray(props.previewCertificateParams?.warnings) && props.previewCertificateParams?.warnings.length > 0) {
      const warningsLi = props.previewCertificateParams?.warnings.reduce((accum: string, element: {key: string, message: string}) => {
        accum += `<li>${element.key}: ${element.message}</li>`
        return accum;
      }, '')
      if (component) {
        warnings = (
          <div className="alert alert-warning">
            <p><b>Información relevante para la generación de certificados</b></p>
            <ul>
              {parse(warningsLi)}
            </ul>
          </div>
        )
      } else {
        warnings = `
        <div className="alert alert-warning">
          <p><b>Información relevante para la generación de certificados</b></p>
          <ul>
            ${warningsLi}
          </ul>
        </div>`
      }
    }
    return {hasWarnings: !!warnings, warnings};
  }

  const certificateNamehasParentheses = (certificateName: string) => /^(\(.*\))/.test(certificateName.trim())

  const auditorCertificateFormatIsCorrect = () => {
    if (
      !props.courseScheduling?.isMultiple &&
      props.courseScheduling?.certificationStrategy === 'huella2' &&
      props?.previewCertificateParams?.certificado_auditor
    ) {
      const hasParentheses = certificateNamehasParentheses(props.previewCertificateParams?.certificado_auditor)
      if (!hasParentheses) return false
    }
    return true
  }


  return (
    <div className=''>
      <Modal
        show={open}
        onHide={() => handleCloseModal({ status: false })}
        className='moda_generate_certifications-component'
        size={props.isAuditorCerficateEnabled || props.firstCertificateIsAuditor ? 'xl' : 'lg'}
      >
        <Modal.Header>
          <Modal.Title>
            {t('screens.course_scheduling.certifications.generate_certification.title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.loading ? (
            <div className='loading'>
              <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
            </div>
          ) : (
            <>
              {props.errors.length > 0 && (
                <div className='alert alert-warning'>
                  <ul>
                    {props.errors.map((error) => (
                      <li>{error}</li>
                    ))}
                  </ul>
                </div>
              )}

              {warnings().warnings}

              {(props.previewCertificateParams) ?
                <label className='form-check-label' htmlFor={`student_1`}>
                  <b>{t('screens.course_scheduling.certifications.generate_certification.certificate_name')}: </b>
                  {props.previewCertificateParams?.certificado} <br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.scheduling_mode')}: </b>
                  {props.schedulingMode} <br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.duration')}: </b>
                  {props.previewCertificateParams?.intensidad} <br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.city')}: </b>
                  {props.previewCertificateParams?.ciudad}<br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.country')}: </b>
                  {props.previewCertificateParams?.pais}<br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.approval_date')}: </b>
                  {props.previewCertificateParams?.dato_2}<br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.content')}: </b>
                  {parse(props.previewCertificateParams?.listado_cursos)}

                </label> : null
              }
              {(props.previewCertificateParams?.certificado_auditor) ?
                <label className='form-check-label' htmlFor={`student_1`}>
                  <b>{t('screens.course_scheduling.certifications.generate_certification.auditor_certificate_name')}: </b>
                  {parse(props.previewCertificateParams?.certificado_auditor)}<br />

                  <b>{t('screens.course_scheduling.certifications.generate_certification.auditor_modules')}: </b>
                  {parse(props.previewCertificateParams?.listado_modulos_auditor)}

                  {!auditorCertificateFormatIsCorrect() && (
                    <div className='alert alert-danger'>
                      Error: El certificado auditor tiene un formato incorrecto. Faltan los paréntesis al inicio del nombre.
                    </div>
                  )}

                </label> : null
              }

              {props.students.length > 0 ? (
                <>
                  <form onSubmit={formHook.handleSubmit(handleFormSubmit)} className=''>
                    <DataTableComponent
                      data={props.students}
                      headerKeys={[
                        (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginLeft: '8px',
                            }}
                          >
                            <input
                              type='checkbox'
                              value='check_all'
                              name={`check_all`}
                              id={`check_all`}
                              onChange={handleSelectAll}
                              checked={isCheckAll}
                            />
                          </div>
                        ),
                        `Code`,
                        `${t('screens.course_scheduling.certifications.generate_certification.student')}`,
                        `${t('screens.course_scheduling.certifications.generate_certification.attended_approved')}`,
                        ...headerKeysByMode(),
                        ...headerKeysForAuditorCertificate(),
                      ]}
                      keys={[
                        'enrollmentCode',
                        'user.profile.full_name',
                        'progress.attended_approved',
                        ...keysByMode(),
                        ...keysForAuditorCertificate(),
                      ]}
                      // pagination={props.pagination}
                      detailsKey={[]}
                      firstColRowButtons={(student) => {
                        return (
                          <>
                            {!student.progress?.status || (student.progress?.status && ['no', 'error'].includes(student.progress?.status)) ? (
                              <div className='checkbox-not-available'>-</div>
                            ) : (
                              <div className='form-check'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  value={`${student.user._id}`}
                                  id={`student_${student.user._id}`}
                                  name={`students`}
                                  onChange={handleCheckClick}
                                  ref={formHook.register()}
                                  checked={isCheck.includes(`student_${student.user._id}`)}
                                  disabled={!student.progress?.status || (student.progress?.status && ['no', 'error'].includes(student.progress?.status)) ? true : false}
                                />
                              </div>
                            )}
                          </>
                        )
                      }}
                      // onPageChange={props.onPageChange}
                      onModal={null}
                    />
                    <div className='buttons-group'>
                      <div className='text-center'>
                        <button
                          className='btn btn-secondary'
                          type='submit'
                          disabled={props.processing || !auditorCertificateFormatIsCorrect()}
                        >
                          {props.processing && (<><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>&nbsp;&nbsp;</>)}
                          {t('modules.modal_generate_certifications.form.save')}
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              ) : (
                <EmptyStateCommon showAddMessage={false} />
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ModalGenerateCertificationsModuleLayout
